import { AccessPermissions } from '@circlefin/permissions'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Access to view the primary approval workflow features - proposals and groups.
 *
 * Add Circle role and break the permission as needed later [https://circlepay.atlassian.net/browse/BBSS-2816].
 */
export const APPROVAL_WORKFLOW_QUERY: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [SynthRole.SYNTH_NEW_APPROVAL_WORKFLOW_ONE],
}
